import React from 'react';
import classNames from 'classnames';
import TransitionGroup from 'react-transition-group/TransitionGroup';
import Transition from 'react-transition-group/CSSTransition';

import {FlagsMenu} from './flags-menu/FlagsMenu';
import {HelpMenu} from './help-menu/HelpMenu';
import {TrayMenu} from './tray-menu/TrayMenu';

import './Tray.less';

export class Tray extends React.Component {
    state = {
        activeMenu: 'tray',
    };

    transitionProps = {
        backdrop: {
            classNames: {
                enter: 'site-header-tray__backdrop--enter',
                enterActive: 'site-header-tray__backdrop--enter-active',
                exit: 'site-header-tray__backdrop--exit',
                exitActive: 'site-header-tray__backdrop--exit-active',
            },
            timeout: 250,
        },
        menu: {
            classNames: {
                enter: 'site-header-tray__menu--enter',
                enterActive: 'site-header-tray__menu--enter-active',
                exit: 'site-header-tray__menu--exit',
                exitActive: 'site-header-tray__menu--exit-active',
            },
            timeout: 500,
        },
    };

    get className() {
        return classNames(
            'site-header-tray',
            {'site-header-tray--open': this.props.isOpen},
        );
    }

    handleClickBackdrop = () => {
        this.props.handleToggleOpen();
        this.setActiveMenu('tray');
    }

    setActiveMenu = (menu = 'tray') => {
        this.setState({
            activeMenu: menu,
        });
    }

    render() {
        return (
            <div className={this.className}>
                <TransitionGroup component="div">
                    {this.props.isOpen && (
                        <Transition {...this.transitionProps.backdrop}>
                            <div
                                className="site-header-tray__backdrop"
                                onClick={this.handleClickBackdrop}
                                onKeyPress={this.handleClickBackdrop}
                                role="none"
                            />
                        </Transition>
                    )}
                </TransitionGroup>

                <TransitionGroup className="site-header-tray__container" component="div">
                    {this.state.activeMenu === 'tray' && (
                        <Transition {...this.transitionProps.menu}>
                            <TrayMenu
                                countryCode={this.props.countryCode}
                                currencyCode={this.props.currencyCode}
                                extraNav={this.props.extraNav}
                                feedbackComponent={this.props.feedbackComponent}
                                flags={this.props.flags}
                                globalizationSelector={this.props.globalizationSelector}
                                handleTravelerLogin={this.handleClickBackdrop}
                                help={this.props.help}
                                inbox={this.props.inbox}
                                languageCode={this.props.languageCode}
                                login={this.props.login}
                                lyp={this.props.lyp}
                                renderCountryLanguageSelector={this.props.renderCountryLanguageSelector}
                                renderCurrencySelector={this.props.renderCurrencySelector}
                                scratchpad={this.props.scratchpad}
                                setActiveMenu={this.setActiveMenu}
                                traveler={this.props.traveler}
                            />
                        </Transition>
                    )}

                    {this.state.activeMenu === 'flag' && (
                        <Transition {...this.transitionProps.menu}>
                            <FlagsMenu
                                flags={this.props.flags}
                                setActiveMenu={this.setActiveMenu}
                            />
                        </Transition>
                    )}

                    {this.state.activeMenu === 'help' && (
                        <Transition {...this.transitionProps.menu}>
                            <HelpMenu
                                help={this.props.help}
                                setActiveMenu={this.setActiveMenu}
                            />
                        </Transition>
                    )}
                </TransitionGroup>
            </div>
        );
    }
}
